import { render, staticRenderFns } from "./SafetyInspectionManage.vue?vue&type=template&id=3f7ff40c&scoped=true&"
import script from "./SafetyInspectionManage.vue?vue&type=script&lang=js&"
export * from "./SafetyInspectionManage.vue?vue&type=script&lang=js&"
import style0 from "./SafetyInspectionManage.vue?vue&type=style&index=0&id=3f7ff40c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7ff40c",
  null
  
)

export default component.exports